<template>
  <div>
    <header class="searchHeader coupons">
      <div class="found">
        <p class="count"><span class="num">{{ coupons.length }}</span>件</p>
      </div>
    </header>
    <section class="couponsListWrap">
      <ul class="couponsList">
        <li v-for="(coupon) in coupons" :key="coupon.id">
          <like-button
              :id="coupon.id"
              :liked="coupon.like_flag"
              :like-count="coupon.liked"
              :content-type="5"
              :auth="auth">
          </like-button>
          <div class="img lazyload" :data-bg="imageStyle(coupon.image_url)">
            <a :href="coupon.shop.url">
              <div class="content">
                <div v-if="coupon.shop.category.name_public" class="genre">
                  {{ coupon.shop.category.name_public}}
                </div>
                <div class="title">
                  {{ coupon.shop.name_ja }}
                </div>
              </div>
            </a>
          </div>
          <div class="text">
            <div class="date">
              <div><span>{{ coupon.display_expiration_end_date }}</span>まで有効</div>
              <a @click="
                selectedCouponId = coupon.id,
                isDetail = true"
                href="javascript:void(0)" class="detail detailCouponButton"
              >
                詳細
              </a>
            </div>
            <div class="title">
              {{ coupon.title }}
            </div>
            <div class="button useCouponButton" @click="
              selectedCouponId = coupon.id,
              isDetail = false
            ">
              クーポンを使う
            </div>
          </div>
        </li>
      </ul>
    </section>
    <Transition name="couponView" @before-enter="beforeEnter" @after-leave="afterLeave">
      <div class="couponView" v-if="selectedCoupon" @click.self="closeCouponView">
        <div class="box" v-if="isDetail">
          <div class="header">
            <div class="headerBox">
              <div class="headerTitle">
                クーポン詳細
              </div>
            </div>
            <div class="close" @click="closeCouponView"></div>
          </div>
          <div class="img detail lazyload" :data-bg="imageStyle(selectedCoupon.image_url)">
            <div class="meta">
              <div class="genre" v-if="selectedCoupon.shop.category.name_public">
                {{ selectedCoupon.shop.category.name_public  }}
              </div>
              <div class="title dashed">
                {{ selectedCoupon.shop.name }} / {{ selectedCoupon.shop.name_ja }}
              </div>
            </div>
          </div>
          <ul class="textDetail">
            <li v-if="selectedCoupon.overview" class="textDetail-content">
              <div class="textDetail-content-title">内容</div>
              <p class="description">
                {{ selectedCoupon.overview }}
              </p>
            </li>
            <li class="textDetail-content">
              <div class="textDetail-content-title">有効期限</div>
              <p class="description">
                {{ selectedCoupon.display_expiration_end_date_en }}
              </p>
            </li>
            <li v-if="selectedCoupon.use_condition" class="textDetail-content">
              <div class="textDetail-content-title">利用条件</div>
              <p class="description">
                {{ selectedCoupon.use_condition }}
              </p>
            </li>
            <div class="detailMore-button-container">
              <a class="button more" :href="selectedCoupon.shop_url">
                店舗情報をみる
              </a>
              <a @click="isDetail = false" class="button use" href="javascript:void(0)">
                クーポンを使う
              </a>
            </div>
          </ul>
        </div>
        <div class="box" v-if="!isDetail">
          <div class="header">
            <div class="headerBox">
              <div class="headerTitle">
                <img src="/assets/img/common/logo.svg" alt="ALOCO" class="logo"> Coupon
              </div>
              <span>Powered by Made in Hawaii TV</span>
            </div>
            <div class="close" @click="closeCouponView"></div>
          </div>
          <div class="img lazyload" :data-bg="imageStyle(selectedCoupon.image_url)">
            <div class="content">
              <div class="title">この画面をスタッフにご提示ください</div>
              <div class="subTitle">
                please present this coupon<br>
                when you order / purchase / check-in.
              </div>
            </div>
          </div>
          <div class="text">
            <div class="genre" v-if="selectedCoupon.shop.category.name_public">
              {{ selectedCoupon.shop.category.name_public  }}
            </div>
            <div class="title dashed">
              {{ selectedCoupon.shop.name }} / {{ selectedCoupon.shop.name_ja }}
            </div>
            <div class="title">
              {{ selectedCoupon.title }}
            </div>
            <p class="description" v-if="selectedCoupon.overview">
              {{ selectedCoupon.overview }}
            </p>
            <dl class="couponDetailList">
              <template v-if="selectedCoupon.use_condition">
                <dt>
                  利用条件 / Conditions
                </dt>
                <dd>
                  {{ selectedCoupon.use_condition }}
                </dd>
              </template>
              <dt>
                有効期限 / Expires
              </dt>
              <dd>
                {{ selectedCoupon.display_expiration_end_date_en }}
              </dd>
            </dl>
            <div class="useCoupon-button-container">
              <audio class="audio" ref="audioElement" controls>
                <source src="/audio/useCoupon.mp3" type="audio/mpeg">
              </audio>
              <button @click="playAudio()" class="button use">
                <div>
                  <span class="en">Can I use this coupon?</span>
                  <span class="ja">このクーポンは使えますか？</span>
                </div>
              </button>
              <p>ボタンをタップすると、音声が流れます</p>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>
<script>
import vClickOutside from 'click-outside-vue3';

export default {
  props: {
    shopCoupons: {
      type: Array,
      required: true
    },
    auth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      couponsError: null,
      coupons: [],
      selectedCouponId: null,
      popup: null,
      isDetail: false,
    }
  },
  mounted() {
    this.coupons = this.shopCoupons;
    this.lazyLoad();
  },
  computed: {
    selectedCoupon() {
      if (!this.selectedCouponId) return null;
      if (!this.coupons) return [];
      return this.coupons.find((coupon) => coupon.id === this.selectedCouponId);
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  methods: {
    lazyLoad() {
      document.addEventListener('lazybeforeunveil', function(e) {
        let bg = e.target.getAttribute('data-bg');
        if (bg){
          e.target.style.backgroundImage = `url("${bg}")`;
        }
      });
    },
    imageStyle(url) {
      return url ?? null;
    },
    onClickOutside() {
      this.popup = this.popup = null
    },
    closeCouponView() {
      this.selectedCouponId = null
    },
    beforeEnter() {
      // .couponViewが表示される前にbodyのoverflowをhiddenにし、スクロールできないようにする
      document.body.style.overflow = "hidden";
    },
    afterLeave() {
      // .couponViewが非表示になった後にbodyのoverflowを削除する
      document.body.style.overflow = "";
    },
    playAudio() {
      const audioElement = this.$refs.audioElement
      audioElement.play()
    }
  }
}
</script>
